/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-23 14:47:32
 **/

import { BaseServiceV2 } from "@/frameworks/libraries/restservice";

class NotficeNotification extends BaseServiceV2 {
	constructor() {
		super();
	}

	private APIPath = (path?: string) => `/api/notices/notifications${path ? `/${path}` : ""}`;

	public inquiry = {
		name: "notification:inquiry",
		execute: (
			parameter: WebServices.Notices.Notification.Inquiry.Request = {}
		): Promise<WebServices.Notices.Notification.Inquiry.Response> =>
			this.get(this.inquiry.name, this.APIPath(), parameter)
	};

	public read = {
		name: "notificationLogs:read",
		execute: (
			parameter: WebServices.Notices.Notification.Read.Request
		): Promise<WebServices.Notices.Notification.Read.Response> =>
			this.post(this.read.name, this.APIPath("read"), parameter)
	};
}

export default class NoticeService {
	constructor(
		events: API.Events,
		public readonly notification = new NotficeNotification()
	) {
		notification.set_event(events);
	}
}
